export var _LEGACY_NotesSectionsKeys;
(function (_LEGACY_NotesSectionsKeys) {
    _LEGACY_NotesSectionsKeys["ALLERGIES"] = "allergies";
    _LEGACY_NotesSectionsKeys["ASSESSMENTS"] = "assessments";
    _LEGACY_NotesSectionsKeys["BILLING"] = "billing";
    _LEGACY_NotesSectionsKeys["CONDITIONS"] = "conditions";
    _LEGACY_NotesSectionsKeys["EXAMINATIONS"] = "examinations";
    _LEGACY_NotesSectionsKeys["HPI"] = "hpi";
    _LEGACY_NotesSectionsKeys["MEDICATIONS"] = "medications";
    _LEGACY_NotesSectionsKeys["NEXT_APPOINTMENT"] = "nextAppointment";
    _LEGACY_NotesSectionsKeys["ORDERS"] = "orders";
    _LEGACY_NotesSectionsKeys["REFERRALS"] = "referrals";
    _LEGACY_NotesSectionsKeys["REVIEW_OF_SYSTEMS"] = "reviewOfSystems";
    _LEGACY_NotesSectionsKeys["SOCIAL_HISTORY"] = "socialHistory";
    _LEGACY_NotesSectionsKeys["SURGICAL_HISTORY"] = "surgicalHistory";
    _LEGACY_NotesSectionsKeys["VITALS"] = "vitals";
    _LEGACY_NotesSectionsKeys["ADDENDUM"] = "addendum";
})(_LEGACY_NotesSectionsKeys || (_LEGACY_NotesSectionsKeys = {}));
export var _LEGACY_NotesEncounterStatuses;
(function (_LEGACY_NotesEncounterStatuses) {
    _LEGACY_NotesEncounterStatuses["NOT_STARTED"] = "notStarted";
    _LEGACY_NotesEncounterStatuses["STARTED"] = "started";
    _LEGACY_NotesEncounterStatuses["CANCELED"] = "canceled";
    _LEGACY_NotesEncounterStatuses["FINISHED"] = "finished";
})(_LEGACY_NotesEncounterStatuses || (_LEGACY_NotesEncounterStatuses = {}));
export var _LEGACY_NotesSectionCompletenessStatuses;
(function (_LEGACY_NotesSectionCompletenessStatuses) {
    _LEGACY_NotesSectionCompletenessStatuses["EMPTY"] = "empty";
    _LEGACY_NotesSectionCompletenessStatuses["UNVERIFIED"] = "unverified";
    _LEGACY_NotesSectionCompletenessStatuses["COMPLETED"] = "completed";
})(_LEGACY_NotesSectionCompletenessStatuses || (_LEGACY_NotesSectionCompletenessStatuses = {}));
export var _LEGACY_NotesSectionReviewStatuses;
(function (_LEGACY_NotesSectionReviewStatuses) {
    _LEGACY_NotesSectionReviewStatuses["EMPTY"] = "empty";
    _LEGACY_NotesSectionReviewStatuses["REVIEWED"] = "reviewed";
    _LEGACY_NotesSectionReviewStatuses["NOT_REVIEWED"] = "notReviewed";
})(_LEGACY_NotesSectionReviewStatuses || (_LEGACY_NotesSectionReviewStatuses = {}));
// todo: change to base ServiceStaffLoadType?
export var _LEGACY_ApptTypes;
(function (_LEGACY_ApptTypes) {
    _LEGACY_ApptTypes["ONSITE"] = "onsite";
    _LEGACY_ApptTypes["VIRTUAL"] = "virtual";
    _LEGACY_ApptTypes["CLINIC"] = "clinic";
})(_LEGACY_ApptTypes || (_LEGACY_ApptTypes = {}));
export var _LEGACY_NotesSources;
(function (_LEGACY_NotesSources) {
    _LEGACY_NotesSources["INTAKE"] = "intake";
    _LEGACY_NotesSources["NOTES"] = "notes";
})(_LEGACY_NotesSources || (_LEGACY_NotesSources = {}));
